import React, { Component } from "react";
import FixedOptions from "../../Search/PanelLeft/FixedOptions/FixedOptions";
import AcquirorsOptions from "../../Search/PanelLeft/AcquirorsOptions/AcquirorsOptions";
import AcquireesOptions from "../../Search/PanelLeft/AcquireesOptions/AcquireesOptions";
import CustomersOptions from "../../Search/PanelLeft/CustomersOptions/CustomersOptions";
import BusinessInput from "../../Search/PanelRight/BusinessInput/BusinessInput";
import Button from "../../Button/Button";
import "./RedoSearch.css";

class RedoSearch extends Component {
	render() {
		let panelStyle;

		if (this.props.revealSearchPanel === true) {
			panelStyle = {
				left: 0
			};
		}
		return (
			<div className="panel-left-redo" style={panelStyle}>
				<FixedOptions
					countries={this.props.countries}
					queryTypeSingular={this.props.queryTypeSingular}
					query={this.props.query}
					//industries={this.props.industries}
					searchProducts={this.props.searchProducts}
					addSearchTypeToQuery={this.props.addSearchTypeToQuery}
					buildSearchQuery={this.props.buildSearchQuery}
				/>
				<section>
					<p className="panel-section-header">
						{this.props.queryTypeSingular}'s Business
					</p>
					<BusinessInput
						query={this.props.query}
						buildSearchQuery={this.props.buildSearchQuery}
					/>
				</section>
				{this.props.query.type === "acquirers" && (
					<AcquirorsOptions
						query={this.props.query}
						queryTypeSingular={this.props.queryTypeSingular}
						buildSearchQuery={this.props.buildSearchQuery}
						moreFilters={this.props.moreFilters}
						toggleMoreFilters={this.props.toggleMoreFilters}
					/>
				)}
				{this.props.query.type === "targets" && (
					<AcquireesOptions
						query={this.props.query}
						queryTypeSingular={this.props.queryTypeSingular}
						buildSearchQuery={this.props.buildSearchQuery}
						moreFilters={this.props.moreFilters}
						toggleMoreFilters={this.props.toggleMoreFilters}
					/>
				)}
				{this.props.query.type === "customers" && (
					<CustomersOptions
						query={this.props.query}
						queryTypeSingular={this.props.queryTypeSingular}
						buildSearchQuery={this.props.buildSearchQuery}
						moreFilters={this.props.moreFilters}
						toggleMoreFilters={this.props.toggleMoreFilters}
					/>
				)}

				<Button
					label={`Find ${this.props.query.type}`}
					onClick={() => this.props.validateSearchQuery()}
				/>
				
				<p></p><p></p><p></p><p></p>
				
				<label><a href="https://www.fmeasure.com/user-instructions" target="_blank"><u>User Instructions</u></a></label>
			</div>
		);
	}
}

export default RedoSearch;


// WEBPACK FOOTER //
// ./src/components/SearchResults/RedoSearch/RedoSearch.js